var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-widget",class:{'date-filtered': _vm.dateFiltered}},[_c('label',[_vm._v(_vm._s(_vm.title))]),_c('h1',[_vm._v(_vm._s(_vm.value))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-widget-footer"},[_c('label',[_vm._v("PEAK: ")])])
}]

export { render, staticRenderFns }